import { getFieldLabel } from 'components/CreationForms/utils/fields';
import { ReactNode, useId } from 'react';
import { cn } from 'utils/style-utils';

export interface FormFieldProps {
  label: string;
  required?: boolean;
  /** The id of a single input inside, so the label names and focuses it. */
  fieldId?: string;
  className?: string;
  labelClassName?: string;
  children: ReactNode;
}

/** A field of a form with its label above it; the label also names the group around it. */
const FormField = ({
  label,
  required,
  fieldId,
  className,
  labelClassName,
  children,
}: FormFieldProps) => {
  const labelId = useId();

  return (
    <div
      role="group"
      aria-labelledby={labelId}
      className={cn('flex flex-col gap-1', className)}
    >
      <label
        id={labelId}
        htmlFor={fieldId}
        className={cn('text-sm text-gray-800', labelClassName)}
      >
        {getFieldLabel(label, required)}
      </label>
      {children}
    </div>
  );
};

export default FormField;
